<script>
    import { onMount } from 'svelte';
    onMount(() => {window.location.href = '/map'});
</script>